import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function TrashIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#FFFFFF';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.75 3.75C1.75 3.33579 2.08579 3 2.5 3H13.5C13.9142 3 14.25 3.33579 14.25 3.75C14.25 4.16421 13.9142 4.5 13.5 4.5H2.5C2.08579 4.5 1.75 4.16421 1.75 3.75Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.75 1.25C4.75 0.835786 5.08579 0.5 5.5 0.5H10.5C10.9142 0.5 11.25 0.835786 11.25 1.25C11.25 1.66421 10.9142 2 10.5 2H5.5C5.08579 2 4.75 1.66421 4.75 1.25Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 3C3.91421 3 4.25 3.33579 4.25 3.75V12.75H11.75V3.75C11.75 3.33579 12.0858 3 12.5 3C12.9142 3 13.25 3.33579 13.25 3.75V13C13.25 13.3315 13.1183 13.6495 12.8839 13.8839C12.6495 14.1183 12.3315 14.25 12 14.25H4C3.66848 14.25 3.35054 14.1183 3.11612 13.8839C2.8817 13.6495 2.75 13.3315 2.75 13V3.75C2.75 3.33579 3.08579 3 3.5 3Z'
        fill={fill}
      />
    </SvgIcon>
  );
}
